export default __webpack_public_path__ + "static/media/preview.36cacdd6.jpg";